import { MenuConfigItem } from 'components/common/SideMenu/SideMenu';

type ExcellenceAppsConfigKey =
    | 'kcRecommendations'
    | 'durationForecast'
    | 'logicQualityCheck'
    | 'learningMaterials'
    | 'activitiesGraph'
    | 'finishDatePrediction'
    | 'scheduleSimulation'
    | 'criticalityAnalysis'
    | 'riskRegister';

export const riskConfig: Record<ExcellenceAppsConfigKey, MenuConfigItem> = {
    kcRecommendations: {
        name: 'Recommendations',
        link: 'kc-recommendations',
        title: 'Recommendations',
        tooltip: 'Recommendations',
    },
    durationForecast: {
        name: 'Duration Forecast',
        link: 'clusterrcfanalysis',
        title: 'Duration Forecast',
        tooltip: 'Duration Forecast',
    },
    logicQualityCheck: {
        name: 'Logic Quality Check',
        link: 'logicChecker',
        title: 'Logic Quality Check',
        tooltip: 'Logic Quality Check',
    },
    finishDatePrediction: {
        name: 'Finish Date Prediction',
        title: 'Finish Date Prediction',
        link: 'finish-date-prediction',
        tooltip: 'Finish Date Prediction',
    },
    learningMaterials: {
        name: 'Learning Materials',
        link: 'learning-center',
        title: 'Learning Materials Gallery',
        tooltip: 'Collection of learning materials media',
    },
    activitiesGraph: {
        name: 'Activities Graph',
        link: 'activities-graph',
        title: 'Activities Graph',
        tooltip: 'Activities Graph',
    },
    scheduleSimulation: {
        name: 'Schedule Simulation',
        link: 'schedule-simulation',
        title: 'Schedule Simulation',
        tooltip: 'Schedule Simulation',
    },
    riskRegister: {
        name: 'Risk Register & QSRA',
        link: 'risk-register',
        title: 'Risk Register & QSRA',
        tooltip: 'Risk Register & QSRA',
    },
    criticalityAnalysis: {
        name: 'Criticality',
        title: 'Criticality',
        link: 'critical-analysis',
        tooltip: 'Criticality',
    },
};
